import React from 'react';
import appointmentImg from '../assets/appointment-journey.webp';

const AppointmentJourney = () => {
  const steps = [
    {
      number: '01',
      title: 'Choose Your Service & Specialist',
      description: 'Select the medical concern that you would like to require support for.'
    },
    {
      number: '02',
      title: 'Select Date & Time',
      description: 'Schedule the consultation at a time that fits your journey and routine.'
    },
    {
      number: '03',
      title: 'Pick Your Doctor & Service',
      description: 'Connect up with your Verified Specialist through a secure platform.'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={appointmentImg}
                alt="Medical journey"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center space-x-2 bg-[#1e3a8a]/5 px-4 py-2 rounded-full mb-4">
              <div className="w-2 h-2 bg-[#22d3ee] rounded-full"></div>
              <span className="text-[#1e3a8a] text-sm font-semibold uppercase tracking-wide">Our Process</span>
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Our Appointment Journey
            </h2>

            <p className="text-gray-600 text-sm sm:text-base md:text-lg mb-8 leading-relaxed">
              Booking your consultation with us is designed to be seamless and transparent from start to finish.
            </p>

            {/* Steps */}
            <div className="space-y-4 sm:space-y-6">
              {steps.map((step, index) => (
                <div key={index} className="flex items-start space-x-4 group">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1e3a8a]/10 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#1e3a8a]/20 transition-colors duration-300">
                    <span className="text-xl sm:text-2xl font-bold text-[#1e3a8a]">{step.number}</span>
                  </div>
                  <div className="pt-1">
                    <h3 className="font-bold text-base sm:text-xl text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentJourney;